import { render } from "./LightboxWhoBought.vue?vue&type=template&id=cb38a5b4&scoped=true"
import script from "./LightboxWhoBought.vue?vue&type=script&lang=js"
export * from "./LightboxWhoBought.vue?vue&type=script&lang=js"

import "./LightboxWhoBought.vue?vue&type=style&index=0&id=cb38a5b4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb38a5b4"]])

export default __exports__